import React, { lazy, Suspense } from "react";
import "@fontsource/poppins";
import "./App.css";
import { CookieSetting } from "cookiesetting-component";
const Body = lazy(() => import("./components/Body"));
const GallerySection = lazy(() => import("./components/GallerySection"));
const Highlights = lazy(() => import("./components/Highlights"));
const Footer = lazy(() => import("./components/Footer"));

function App() {
  const imgCDNURL = process.env.REACT_APP_Time2BUY_CDN_URL;

  return (
    <>
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    <div className="bodyContainer">
      <img
        src={imgCDNURL + "background-lines.png"}
        className="body-bg-lines img-fluid"
      />
      <Suspense fallback={<div />}>
        <Body />
      </Suspense>
      <Suspense fallback={<div />}>
        <GallerySection />
      </Suspense>
      <Suspense fallback={<div />}>
        <Highlights />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
    </div>
    </>
  );
}

export default App;
